module.exports = __webpack_public_path__ + "static/img/login-bg-zn.ae2978b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg-zn.jpg
// module id = XEY+
// module chunks = 1